import type { CSSProperties } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import type {
  Region,
  SHADOW_FROM_DIRECTION,
} from './OverscrollShadowContainer';

export type OverscrollShadowProps = Omit<BoxProps, 'gridArea'> & {
  gridArea: Region;
  boxShadow?: SHADOW_FROM_DIRECTION | string;
  depth?: number;
  sx?: CSSProperties;
};

/**
 * Renders a shadow that is positioned to be visible when the parent element has
 * overscroll in a given direction.
 **/
export const OverscrollShadow = ({
  gridArea,
  boxShadow,
  depth = 1,
  ...props
}: OverscrollShadowProps) => {
  const { sx, ...rest } = props;

  return (
    <Box
      boxSize="100%"
      boxShadow={boxShadow}
      gridArea={gridArea}
      sx={{
        '--blur': `calc(${depth} * var(--depth-unit))`,
        ...sx,
      }}
      {...rest}
    />
  );
};
